// modules/timesheet/utils/stats.js
import {
  isToday,
  isYesterday,
  differenceInDays,
  parseISO,
  isSameMonth,
} from "date-fns";

export function computeTimesheetStats(logs) {
  const today = new Date();
  const result = {
    today: 0,
    yesterday: 0,
    last7Days: 0,
    thisMonth: 0,
  };

  for (const log of logs) {
    const logDate = parseISO(log.date);
    const hours = log.logged_hours || 0;

    if (isToday(logDate)) result.today += hours;
    if (isYesterday(logDate)) result.yesterday += hours;
    if (differenceInDays(today, logDate) < 8 && !isToday(logDate)) {
      result.last7Days += hours;
    }
    if (isSameMonth(logDate, today)) result.thisMonth += hours;
  }

  return result;
}
